import { render } from "./SupplierReviews.vue?vue&type=template&id=6ffc21d4&scoped=true"
import script from "./SupplierReviews.vue?vue&type=script&lang=js"
export * from "./SupplierReviews.vue?vue&type=script&lang=js"

import "./SupplierReviews.vue?vue&type=style&index=0&id=6ffc21d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffc21d4"]])

export default __exports__